"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wordSpacing = void 0;
var _styledSystem = require("styled-system");
var defaults = {
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var wordSpacingConfig = {
  wordSpacing: {
    property: 'wordSpacing',
    defaultScale: defaults.fontSizes
  }
};
var wordSpacing = (0, _styledSystem.system)(wordSpacingConfig);
exports.wordSpacing = wordSpacing;